import { render } from "./FormularioTipoPagamento.vue?vue&type=template&id=1e27f2d0&scoped=true"
import script from "./FormularioTipoPagamento.vue?vue&type=script&lang=js"
export * from "./FormularioTipoPagamento.vue?vue&type=script&lang=js"

import "./FormularioTipoPagamento.vue?vue&type=style&index=0&id=1e27f2d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e27f2d0"]])

export default __exports__